import { Layout } from "antd";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { apiGetToken } from "../api/auth";
import { Routes } from "./content";
import "./index.css";
import { LoginForm } from "./loginForm";
import { CustomMenu } from "./menu";
import { userToken } from "./state";

export const App = () => {
  const [token, setToken] = useRecoilState(userToken);

  const authFunc = async (
    login: string,
    password: string,
    remember: boolean,
    setLoading?: any
  ) => {
    try {
      if (setLoading) setLoading(true);
      const auth = await apiGetToken({ login, password });
      setToken(auth.token);
      if (remember) {
        localStorage.setItem("token", auth.token);
      }
    }
    finally {
      if (setLoading) setLoading(false);
    }
  };

  const logoutFunc = () => {
    localStorage.removeItem("token");
    setToken(undefined);
  };

  useEffect(() => {
    const tokenFromLocalStorage = localStorage.getItem("token");
    if (tokenFromLocalStorage) setToken(tokenFromLocalStorage);
  }, []);

  return token ? (
    <Layout className="App">
      <Layout.Header>
        <CustomMenu logoutFunc={logoutFunc} />
      </Layout.Header>
      <Layout>
        <Layout.Content>
          <Routes />
        </Layout.Content>
      </Layout>
    </Layout>
  ) : (
    <LoginForm authFunc={authFunc} />
  );
};
